import * as React from 'react'

import { FlexCentered } from '~ui/components/layout/Box'
import { Text } from '~ui/components/typography/Text/Text'

type TFlexProps = Pick<PropsOf<typeof FlexCentered>, 'margin' | 'bgColor' | 'justifySelf'>

type TProps = RequiredChildren & TFlexProps

/**
 * Rounded badge with the uppercase text.
 */
export const Badge: React.FC<TProps> = ({ children, ...flexProps }) => {
  return (
    <FlexCentered
      {...flexProps}
      radius={`rounded`}
      padding={{ horizontal: `small`, vertical: `none` }}
      textAlign={`center`}
    >
      <Text
        textTransform={`uppercase`}
        fontSize={`s12`}
        fontStyle={`boldSemi`}
        contrast={`high`}
        lineHeight={1.6} // add some space above and below the text to make it look better especially with diacritics
      >
        {children}
      </Text>
    </FlexCentered>
  )
}
